import { Link } from 'react-router-dom';

export default function Footer() {
  const socialLinks = [
    { icon: 'ri-twitter-x-line', label: 'Twitter', href: 'https://twitter.com/themusclehustlepodcast' },
    { icon: 'ri-instagram-line', label: 'Instagram', href: 'https://instagram.com/themusclehustlepodcast' },
    { icon: 'ri-linkedin-line', label: 'LinkedIn', href: 'https://linkedin.com/company/themusclehustlepodcast' },
    { icon: 'ri-youtube-line', label: 'YouTube', href: 'https://www.youtube.com/@themusclehustlepodcast' },
    { icon: 'ri-spotify-fill', label: 'Spotify', href: 'https://open.spotify.com/show/0YDMrdRFUWloLaDufAsYVH?si=99uxCv_tTMKmcqP_gXkUlw' },
    { icon: 'ri-apple-fill', label: 'Apple Podcasts', href: 'https://podcasts.apple.com/us/podcast/the-muscle-hustle-podcast/id1677247639' }
  ];

  const quickLinks = [
    { label: 'Shop', href: '/collective' },
    { label: 'Episodes', href: '/episodes' },
    { label: 'About Us', href: '/about' },
    { label: 'Contact', href: '#' },
    { label: 'Subscribe', href: '#' },
    { label: 'Privacy Policy', href: '#' },
    { label: 'Terms of Service', href: '#' }
  ];

  return (
    <footer className="bg-black text-white py-12 md:py-16">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-8 md:gap-12 max-w-7xl mx-auto">
          <div className="md:col-span-3 lg:col-span-3 text-center">
            <div className="flex flex-col items-center gap-4 mb-4">
            </div>
            
            <p className="text-red-400 text-base md:text-lg font-semibold mb-4">
              Where the Everyday Hustle is Respected
            </p>
            <p className="text-gray-400 text-lg md:text-xl lg:text-2xl mb-6 max-w-md mx-auto leading-relaxed">
              Bringing you thought-provoking conversations that honor The Grind. The Drive. The Hustle. Join our community of hustlers who Respect My Hustle.
            </p>
            <div className="flex flex-wrap gap-2 mb-6 md:mb-8 justify-center">
              <span className="bg-red-600/20 text-red-400 px-2 md:px-3 py-1 rounded-full text-xs md:text-sm font-semibold">#TheGrind</span>
              <span className="bg-red-600/20 text-red-400 px-2 md:px-3 py-1 rounded-full text-xs md:text-sm font-semibold">#TheDrive</span>
              <span className="bg-red-600/20 text-red-400 px-2 md:px-3 py-1 rounded-full text-xs md:text-sm font-semibold">#TheHustle</span>
              <span className="bg-red-600/20 text-red-400 px-2 md:px-3 py-1 rounded-full text-xs md:text-sm font-semibold">#RespectMyHustle</span>
            </div>
            <div className="flex gap-3 md:gap-4 justify-center">
              {socialLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  aria-label={link.label}
                  className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-gray-800 hover:bg-red-600 rounded-full transition-colors cursor-pointer"
                >
                  <i className={`${link.icon} text-lg md:text-xl`}></i>
                </a>
              ))}
            </div>
          </div>
          
          <div className="lg:ml-8">
            <h4 className="text-xl md:text-2xl font-bold mb-4 md:mb-6">Quick Links</h4>
            <ul className="space-y-3 md:space-y-4">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.href}
                    className="text-gray-400 hover:text-white transition-colors cursor-pointer text-base md:text-lg"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          
          <div className="lg:ml-4">
            <h4 className="text-xl md:text-2xl font-bold mb-4 md:mb-6">Listen On</h4>
            <div className="space-y-3 md:space-y-4">
              <a 
                href="https://open.spotify.com/show/0YDMrdRFUWloLaDufAsYVH?si=99uxCv_tTMKmcqP_gXkUlw" 
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors cursor-pointer text-base md:text-lg"
              >
                <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center">
                  <i className="ri-spotify-fill text-green-500"></i>
                </div>
                Spotify
              </a>
              <a 
                href="https://podcasts.apple.com/us/podcast/the-muscle-hustle-podcast/id1677247639" 
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors cursor-pointer text-base md:text-lg"
              >
                <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center">
                  <i className="ri-apple-fill"></i>
                </div>
                Apple Podcasts
              </a>
              <a 
                href="https://www.youtube.com/@themusclehustlepodcast" 
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors cursor-pointer text-base md:text-lg"
              >
                <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center">
                  <i className="ri-youtube-fill text-red-500"></i>
                </div>
                YouTube
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-8 md:mt-12 pt-6 md:pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-center md:text-left">
            <p className="text-gray-400 text-base md:text-lg">
              © 2024 The Muscle Hustle Podcast. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors cursor-pointer text-base md:text-lg"
              >
                Made with Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
